import { eventTracker } from "@/app/types"
import { Button } from "@/components/buttons/button"
import { FeedbackPopup } from "@/components/popups/popup.feedback"
import { ChatCircleDots } from "@phosphor-icons/react"
import { useState } from "react"

export function FeedbackButton() {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpenFeedbackModal = () => {
    setIsOpen(true)
    eventTracker.trackEvent({
      event: "app:feedback_view",
    })
  }

  return (
    <>
      <FeedbackPopup close={() => setIsOpen(false)} isOpen={isOpen} />
      <Button
        className="print:hidden"
        onClick={handleOpenFeedbackModal}
        color="tertiary">
        <ChatCircleDots />
      </Button>
    </>
  )
}
